import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import {injectIntl} from 'react-intl';
import {connect} from "react-redux";

import apiCalls from '../../utils/apiCalls';
import utils from '../../utils/utils';
import GeneralForm from "../../components/generalForm";
import DATE_FORMAT from "../../components/constants/dateFormat";

function OrderForm({intl, orderId, onSuccess}) {
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [order, setOrder] = useState(null);

  useEffect(() => {
    if (orderId) {
      setOrder(null);
      setLoading(true);
      setError(null);

      apiCalls.getOrders({
        orderId,
      })
        .then((result) => {
          if (result.data && result.data.orders.length) {
            const order = getOrderObject(result.data.orders[0])
            setOrder(order);
            setLoading(false);
          }
        })
        .catch((errors) => {
          setError(utils.getErrorMessageFromResponse(errors, true));
          setLoading(false);
        });
    }
  }, [orderId]);

  const formSchema = {
    type: "object",
    required: [],
    properties: {
      deliveryFrom: {
        type: "string",
        title: intl.formatMessage({id: 'order.form.field.delivery.from.label'}),
      },
      deliveryTo: {
        type: "string",
        title: intl.formatMessage({id: 'order.form.field.delivery.to.label'}),
      },
      deliveryDayId: {
        type: "string",
        title: intl.formatMessage({id: 'order.form.field.delivery.day.id.label'}),
      },
    }
  };

  const uiSchema = {
  };

  const onFormSubmit = () => {
    setLoading(true);

    apiCalls.editOrder({order})
      .then((response) => {
        onSuccess(response.data.order);
      })
      .catch((error) => {
        setError(utils.getErrorMessageFromResponse(error, true));
        setLoading(false);
        window.scrollTo(0, 0);
      });
  };

  const formFields = {
  };

  const buttonCopy = 'order.edit.form.submit';
  
  return (
    <div>
      {order ? (
        <GeneralForm onChange={(event) => setOrder(event.formData)}
                     onSubmit={onFormSubmit}

                     formSchema={formSchema}
                     formUiSchema={uiSchema}
                     formFields={formFields}

                     formData={order}

                     buttonCopy={buttonCopy}
                     errorMessage={error}
                     loading={loading}
                     hideImageUpload={true}/>
      ) : ''}
    </div>
  );
}

function getOrderObject(order) {
  const deliveryFrom = utils.getDateFromString(order.deliveryFrom, DATE_FORMAT.dataTransfer);
  const deliveryTo = utils.getDateFromString(order.deliveryTo, DATE_FORMAT.dataTransfer);

  return {
    ...order,
    deliveryFrom: deliveryFrom.format('HH:mm'),
    deliveryTo: deliveryTo.format('HH:mm'),
    deliveryDayId: order.deliveryDayId.toString(),
  }
}

OrderForm.propTypes = {
  onSuccess: PropTypes.func.isRequired,
};

OrderForm.defaultProps = {
  onSuccess: () => {},
};

function mapStateToProps(state) {
  return {
    currentUser: state.currentUser.user,
  };
}

const mapDispatchToProps = {};

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(OrderForm));